import React from 'react';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';

export interface DenseTableProps {
  label?: string;
  head: string[];
  rows: (string | number | React.ReactNode)[][];
}

export function DenseTable({ label, head, rows }: DenseTableProps) {
  return (
    <Box>
      {label ? (
        <Typography variant="subtitle2" color="text.primary" sx={{ mb: 0.5, fontWeight: 700 }}>
          {label}
        </Typography>
      ) : null}
      <Table size="small" sx={{
        '& .MuiTableCell-root': { py: 0.5, px: 1 },
        '& .MuiTableRow-root': { height: 36 },
      }}>
        <TableHead>
          <TableRow>
            {head.map((h, i) => (
              <TableCell key={i} sx={{ fontWeight: 700 }}>{h}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={head.length} align="center">No data</TableCell>
            </TableRow>
          ) : (
            rows.map((r, idx) => (
              <TableRow key={idx} hover>
                {r.map((c, cidx) => (
                  <TableCell key={cidx}>{c as any}</TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  );
}
